import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';
import { whatsappNumber } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/logo.png" alt="Data Clouds" className="footer-logo-image" />
            <p className="body-small mt-2">
              Building intelligent digital systems that transform businesses, schools, and colleges with cutting-edge technology solutions.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="heading-3 mb-3">Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Website Development</Link></li>
              <li><Link to="/services">Mobile Applications</Link></li>
              <li><Link to="/services">AI Agents & Automation</Link></li>
              <li><Link to="/services">Business Process Automation</Link></li>
              <li><Link to="/services">Data Analytics</Link></li>
              <li><Link to="/services">Digital Marketing</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="heading-3 mb-3">Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="heading-3 mb-3">Get In Touch</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={18} />
                <a href="mailto:dataclouds.ai@gmail.com" target="_blank" rel="noopener noreferrer">dataclouds.ai@gmail.com</a>
              </li>
              <li>
                <Phone size={18} />
                <a href={`https://wa.me/${whatsappNumber.replace(/\+/g, '')}`} target="_blank" rel="noopener noreferrer">
                  {whatsappNumber}
                </a>
              </li>
              <li>
                <MapPin size={18} />
                <span>Global Services, 25+ Countries</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small">
            © {currentYear} Data Clouds. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
